export default __webpack_public_path__ + "static/media/online-pk-5-banner.31889fd4.png";